import { useEffect } from "react";

import type { RouteMeta } from "./meta";

function ensureMeta(name: string): HTMLMetaElement {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.name = name;
    document.head.append(element);
  }
  return element;
}

export function HeadManager({ meta }: { meta: RouteMeta }) {
  useEffect(() => {
    document.title = meta.title;
    ensureMeta("description").content = meta.description;
    ensureMeta("robots").content = meta.noIndex
      ? "noindex,nofollow"
      : "index,follow,max-image-preview:large";

    document.head
      .querySelectorAll('[data-living1991-head="true"]')
      .forEach((element) => element.remove());

    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = meta.canonical;
    canonical.dataset.living1991Head = "true";
    document.head.append(canonical);

    for (const alternate of meta.alternates) {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = alternate.hreflang;
      link.href = alternate.href;
      link.dataset.living1991Head = "true";
      document.head.append(link);
    }

    for (const value of meta.jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(value).replace(/</g, "\\u003c");
      script.dataset.living1991Head = "true";
      document.head.append(script);
    }
  }, [meta]);
  return null;
}
